<template>
  <div class="-asset-overlay">
    <transition name="wt2-fade-fast">
      <span class="-play" v-if="showPlayIcon">▶︎</span>
    </transition>
    <div class="-bottom-info">
      <div class="-left">
        <span v-if="!!date" class="-date" :title="dateFull">{{ date }}</span>
      </div>
      <div class="-right">
        <div
          v-if="isAssetRestricted"
          class="-icon -restricted"
          v-tooltip="tooltipOptions"
        >
          <span class="wticon wticon-Restriction_v8"></span>
        </div>
        <slot name="append-right"></slot>
      </div>
    </div>
    <div v-if="!!caption" class="-caption">{{ caption }}</div>
  </div>
</template>
<script>
import Vue from 'vue';

export default Vue.extend({
  props: {
    showPlayIcon: {
      type: Boolean,
      default: false,
    },
    date: {
      type: String,
    },
    dateFull: {
      type: String,
    },
    caption: {
      type: String,
    },
    isAssetRestricted: {
      type: Boolean,
      default: false,
    },
    restrictionsText: {
      type: String,
      required: false,
    },
  },

  computed: {
    tooltipOptions() {
      return this.isAssetRestricted
        ? {
            animation: false,
            trigger: 'hover focus',
            container: '.wt2-asset-gallery .-scroll-container',
            placement: 'bottom auto',
            viewport: {
              selector: '.wt2-asset-gallery .-scroll-container',
              padding: 2,
            },
            delay: { show: 250, hide: 0 },
            wrapperClass: 'tooltip-restrictions-wrapper',
            title: `
<div class="tooltip-restrictions">
    <div class="-title">Restrictions:</div>
    <div class="-description">${this.restrictionsText}</div>
</div>`.normalizeSpace(),
            html: true,
          }
        : {};
    },
  },
});
</script>
